export function getTransformedCloudinaryUrl(
  url,
  options = "w_800,q_auto,f_auto"
) {
  if (!url) return url;
  // Remove any existing transformation after /upload/
  return url.replace(/\/upload\/([^/]*)/, `/upload/${options}`);
}
